import { useCustomPreferences } from '../utils/api';
import { CustomPreference } from '../utils/api/CustomPreference';
import type { Product } from '../bff-api/products/model';

export const FREE_SHIPPING_LABEL = 'FREE';

export const SHIPS_FREE_LIST = [
    'ships free',
    'ships-free',
    'ships_free',
    'ship free',
    'ship-free',
    'ship_free',
];

export const useIsFreeShipping = (): ((product: Product, quantity: number) => boolean) => {
    const customPreferenceData =
        useCustomPreferences([
            CustomPreference.ENABLE_THRESHOLD_SHIPPING,
            CustomPreference.THRESHOLD_SHIPPING_AMOUNT,
            CustomPreference.ENABLE_PDP_FREE_SHIPPING_LABEL,
        ]) ?? {};

    const enableThresholdShipping =
        customPreferenceData[CustomPreference.ENABLE_THRESHOLD_SHIPPING] ?? false;
    const enablePDPFreeShippingLabel =
        customPreferenceData[CustomPreference.ENABLE_PDP_FREE_SHIPPING_LABEL] ?? false;

    return (product: Product, quantity: number): boolean => {
        if (!enablePDPFreeShippingLabel) {
            return false;
        }

        const { price, c_promotions } = product;

        const promo = c_promotions?.find(({ promotionId }) =>
            SHIPS_FREE_LIST.some((shipsFree) => promotionId.toLowerCase().includes(shipsFree)),
        );
        if (!enableThresholdShipping && !promo) {
            return false;
        }

        const threshold =
            (customPreferenceData[CustomPreference.THRESHOLD_SHIPPING_AMOUNT] as number) ?? 70;
        const currentPrice = price ?? 0;

        const totalPrice = currentPrice * quantity;

        return totalPrice >= threshold || !!promo;
    };
};
